export default __webpack_public_path__ + "static/media/7.340868a6.jpg";